<template>

    <div class="row">
        <div class="col-sm-6">
            <div class="box box-solid">
                <div class="box-header">
                    <h2 class="box-title">Openstaande facturen</h2>
                    <div class="box-tools">
                        <div class="btn-group btn-group-sm">
                            <json-excel
                                :data="getOpenJSONData"
                                :disabled="getOpenJSONData.length === 0"
                                :name="getExportName('open')"
                                v-tooltip="'Exporteren naar Excel'"
                                class="btn btn-default"
                            >
                                <i class="mdi mdi-file-excel-box"></i>
                            </json-excel>
                            <button
                                class="btn btn-default"
                                @click="exportToPdfOpen()"
                                v-tooltip="'Exporteren naar PDF'"
                            >
                                <i class="mdi mdi-file-pdf-box"></i>
                            </button>
                        </div>
                    </div>
                </div>
                <div class="box-body no-padding">
                    <table class="table table-striped table-hover" id="openinvoices-open">
                        <thead>
                            <tr>
                                <th>Factuurnummer</th>
                                <th>Factuurdatum</th>
                                <th>Klant</th>
                                <th class="text-right">Totaalbedrag</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-if="open.length === 0"><td colspan="4">Er zijn geen openstaande facturen</td></tr>
                            <tr v-for="invoice in open">
                                <td>
                                    <a
                                        @click="openInvoicesModal(invoice)"
                                        style="display:block;"
                                    >
                                        {{ invoice.invoice_nr }}
                                        <span v-if="invoice.invoice_nr === '' || invoice.invoice_nr === null">&ndash;</span>
                                    </a>
                                </td>
                                <td>{{ invoice.date }}</td>
                                <td>{{ invoice.contact }}</td>
                                <td class="text-right">{{ invoice.sub_total | toCurrency }}</td>
                            </tr>
                        </tbody>
                        <tfoot>
                            <tr>
                                <td colspan="4" class="text-right">Totaal: {{ totals.open | toCurrency }}</td>
                            </tr>
                        </tfoot>
                    </table>
                </div>
            </div>
        </div>
        <div class="col-sm-6">
            <div class="box box-solid">
                <div class="box-header">
                    <h2 class="box-title">Verlopen facturen</h2>
                    <div class="box-tools">
                        <div class="btn-group btn-group-sm">
                            <json-excel
                                :data="getExpiredJSONData"
                                :disabled="getExpiredJSONData.length === 0"
                                :name="getExportName('expired')"
                                v-tooltip="'Exporteren naar Excel'"
                                class="btn btn-default"
                            >
                                <i class="mdi mdi-file-excel-box"></i>
                            </json-excel>
                            <button
                                class="btn btn-default"
                                @click="exportToPdfExpired()"
                                v-tooltip="'Exporteren naar PDF'"
                            >
                                <i class="mdi mdi-file-pdf-box"></i>
                            </button>
                        </div>
                    </div>
                </div>
                <div class="box-body no-padding">
                    <table class="table table-striped table-hover" id="openinvoices-expired">
                        <thead>
                            <tr>
                                <th>Factuurnummer</th>
                                <th>Factuurdatum</th>
                                <th>Klant</th>
                                <th>Totaalbedrag</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="invoice in expired">
                                <td>
                                    <a
                                        @click="openInvoicesModal(invoice)"
                                        style="display:block;"
                                    >
                                        {{ invoice.invoice_nr }}
                                        <span v-if="invoice.invoice_nr === '' || invoice.invoice_nr === null">&ndash;</span>
                                    </a>
                                </td>
                                <td>{{ moment(invoice.date).format("DD-MM-YYYY") }}</td>
                                <td>{{ invoice.contact }}</td>
                                <td class="text-right">{{ invoice.sub_total | toCurrency }}</td>
                            </tr>
                        </tbody>
                        <tfoot>
                            <tr>
                                <td colspan="4" class="text-right">Totaal: {{ totals.expired | toCurrency }}</td>
                            </tr>
                        </tfoot>
                    </table>
                </div>
            </div>
        </div>
        <business-invoice-modal ref="invoiceModal"></business-invoice-modal>
    </div>

</template>

<script>

import axios from 'axios';
import moment from 'moment';
import BusinessInvoiceModal from './InvoiceModal';
import jsPDF from "jspdf";
import JsonExcel from 'vue-json-excel';

export default {

    components: {
        BusinessInvoiceModal,
        JsonExcel,
    },

    computed: {
        getExpiredJSONData() {
            return this.expired.map((invoice) => {
                return {
                    'invoice_number': invoice.invoice_nr,
                    'invoice_date': invoice.date,
                    'client': invoice.contact,
                    'total': invoice.sub_total,
                };
            });
        },
        getOpenJSONData() {
            return this.open.map((invoice) => {
                return {
                    'invoice_number': invoice.invoice_nr,
                    'invoice_date': invoice.date,
                    'client': invoice.contact,
                    'total': invoice.sub_total,
                };
            });
        },
    },

    data() {
        return {
            expired:[],
            moment:moment,
            open:[],
            totals: {
                expired:0,
                open:0,
            },
        }
    },

    methods: {

        exportToPdfExpired() {
            let doc = new jsPDF({orientation:'landscape'});
            let style = {fontSize:7};
            doc.autoTable({
                html:'#openinvoices-expired',
                bodyStyles: style,
                footStyles: style,
            });
            doc.save(this.getExportName('expired') + '.pdf');
        },

        exportToPdfOpen() {
            let doc = new jsPDF({orientation:'landscape'});
            let style = {fontSize:7};
            doc.autoTable({
                html:'#openinvoices-open',
                bodyStyles: style,
                footStyles: style,
            });
            doc.save(this.getExportName('open') + '.pdf');
        },

        getExportName(type) {
            return 'invoices-' + type + '-' + moment().format('YYYY-MM-DD-HH-mm');
        },

        getData() {
            axios.get(this.dataUri)
            .then(resp => {
                this.expired = resp.data.expired;
                this.open = resp.data.open;
                this.totals.expired = resp.data.totalexpired;
                this.totals.open = resp.data.totalopen;
            });
        },

        openInvoicesModal(invoice) {
            // Open the invoice modal
            this.$refs.invoiceModal.openModal(invoice.taskurl, {}, invoice);
        },
    },

    mounted() {
        this.getData();
    },

    name:"BusinessOpenInvoices",

    props: {
        dataUri: { required:true },
    },

}

</script>
